module.exports = __webpack_public_path__ + "img/upload_wall_6.7bd5a513.webp";